<template>
	<a target="_blank" :href="asegurarURL(medio, valor) || 'javascript:void(0)'">
		<VContactoBoton :medio="medio" :tamaño="tamaño"></VContactoBoton>
	</a>
</template>

<script>
import VContactoBoton from '@/components/base/VContactoBoton.vue'
import { asegurarURL } from '@/contactoExterno'

export default {
	name: 'VContactoBotonEnlace',

	components: {
		VContactoBoton
	},

	props: {
		medio: {
			type: String,
			required: true
		},
		valor: {
			type: String
		},
		tamaño: {
			type: String
		}
	},

	methods: {
		asegurarURL: asegurarURL
	}

}

</script>
